import { Link, type LinkComponentProps } from "@tanstack/react-router";
import { identity } from "es-toolkit";

export function PreserverSearchLink(props: Omit<LinkComponentProps, "search">) {
	return <Link {...props} search={identity} />;
}
